//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

(function() {
  const curalate = angular.module('curalate');

  curalate.service('ErrorNotificationService', [
    '$modal',
    '$sce',
    function(
            $modal,
            $sce,
        ) {
      const DEFAULT_TITLE = 'Nuts! That didn\'t work...';

      this.showErrorDialog = function(title, message, errorId, size) {
        size = size || 'small';

        return $modal.open({
          template: '<confirmation-modal ' +
                                    'close="$close(result)" ' +
                                    'confirm-text="\'Ok\'" ' +
                                    'modal-title="modalTitle" ' +
                                    'submit-action="angular.noop" ' +
                                    'hide-cancel-button="true">' +
                                '<p ng-bind-html="message"></p>' +
                                '<p ng-if="errorId" ng-bind-html="errorId"></p>' +
                              '</confirmation-modal>',
          windowClass: `pure-bs3 confirmation-modal-container modal-${size}`,
          controller: ['$scope', 'message', 'title', 'errorId',
            function($scope, message, title, errorId) {
                            /* eslint no-shadow: off */
              $scope.modalTitle = title;
              $scope.message = $sce.trustAsHtml(message);
              if (typeof errorId !== 'undefined' && errorId !== null) {
                $scope.errorId = $sce.trustAsHtml(`Error Id: ${errorId}`);
              }
            },
          ],
          resolve: {
            message() { return message; },
            title() { return title; },
            errorId() { return errorId; },
          },
        });
      };

      this.showDefaultErrorDialog = function(message, error) {
        const errorId = (typeof error === 'object') ? error.errorId : error;
        this.showErrorDialog(DEFAULT_TITLE, message, errorId);
      };

      this.showTrackLimitErrorDialog = function(error) {
        const errorComponents = error.split('::');
        const sourceType = errorComponents[1];
        const errorNumber = errorComponents[2];
        const errorMessage = `Uh oh! You've hit your limit of ${errorNumber} tracked ${sourceType}s.<br><br>` +
                    `You can manage your tracked ${sourceType}s in your <a href="/library/tracked-sources/${sourceType}s">tracked sources</a>.`;
        this.showErrorDialog('Track Limit Reached', errorMessage);
      };

      this.showCollectionTrackLimitErrorDialog = function(error) {
        const errorComponents = error.split('::');
        const sourceType = errorComponents[1];
        const errorNumber = errorComponents[2];
        const errorMessage = `Uh oh! We were unable to add this ${sourceType} to your Collection because you have hit your limit of ${errorNumber} 
                                      tracked ${sourceType}s.<br><br>` +
                    `You can manage your tracked ${sourceType}s in your <a href="/library/tracked-sources/${sourceType}s">tracked sources</a>.`;
        this.showErrorDialog('Track Limit Reached', errorMessage);
      };

      this.showNewCollectionTrackLimitErrorDialog = function(error) {
        const errorComponents = error.split('::');
        const sourceType = errorComponents[1];
        const errorNumber = errorComponents[2];
        const errorMessage = `Uh oh! We were unable to add this ${sourceType} to a new Collection because you have hit your limit of ${errorNumber} 
                                      tracked ${sourceType}s.<br><br>` +
                    `You can manage your tracked ${sourceType}s in your <a href="/library/tracked-sources/${sourceType}s">tracked sources</a>.`;
        this.showErrorDialog('Track Limit Reached', errorMessage);
      };

      this.showListTrackLimitErrorDialog = function(error) {
        let sourceType;
        let errorNumber;
        if (error.startsWith('maxusers')) {
          sourceType = 'user';
          errorNumber = error.split(':')[1];
        } else {
          sourceType = error.split('::')[1];
          errorNumber = error.split('::')[2];
        }
        const errorMessage = `Uh oh! We were unable to add this user to your Influencer List because you have hit your limit of ${errorNumber} 
                                      tracked users.<br><br>` +
                    `You can manage your tracked ${sourceType}s in your <a href="/library/tracked-sources/${sourceType}s">tracked sources</a>.`;
        this.showErrorDialog('Track Limit Reached', errorMessage);
      };

      this.showNewListTrackLimitErrorDialog = function(error) {
        const errorComponents = error.split('::');
        const sourceType = errorComponents[1];
        const errorNumber = errorComponents[2];
        const errorMessage = `Uh oh! We were unable to add this user to a new Influencer List because you have hit your limit of ${errorNumber} 
                                      tracked users.<br><br>` +
                    `You can manage your tracked ${sourceType}s in your <a href="/library/tracked-sources/${sourceType}s">tracked sources</a>.`;
        this.showErrorDialog('Track Limit Reached', errorMessage);
      };
    },
  ]);
})();
